module.exports = {
      id: "Ballon_Electrique-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Ballon_Electrique-usage",
      toString: function () {
        return this.url;
      }
    }